import { Refresh } from "@mui/icons-material";
import { Grid, IconButton, Typography } from "@mui/material"; // ⬅ use Grid
import { Column } from "components/common/Layout/Column";
import { Row } from "components/common/Layout/Row";
import { TravelCard } from "components/partials/TravelCard/TravelCard";
import useSelectedSector from "hooks/useSelectedSector";
import { useEffect, useRef, useState, useCallback } from "react";
import { TravelOffer } from "types/TravelOffer";
import TravelOfferDetailsModal from "./TravelOfferDetailsModal";
import TravelOfferService from "services/TravelOfferService";

const TravelsHistory = () => {
  const { selectedSectorId } = useSelectedSector();
  const [page, setPage] = useState(1);

  const { data, isFetching, refetch } = TravelOfferService.useGetTravelOffersHistoryQuery(
    { sectorId: selectedSectorId, page },
    { refetchOnMountOrArgChange: true },
  );

  const offers = data?.data ?? [];
  const bottomRef = useRef<HTMLDivElement | null>(null);
  useEffect(() => {
    if (!bottomRef.current) return;
    const io = new IntersectionObserver(([e]) => {
      if (e.isIntersecting && !isFetching && (data?.meta?.page || 0) < (data?.meta?.totalPages || 0)) {
        setPage((p) => p + 1);
      }
    });
    io.observe(bottomRef.current);
    return () => io.disconnect();
  }, [bottomRef, isFetching, data]);

  const [selectedTravelOffer, setSelectedTravelOffer] = useState<TravelOffer | null>(null);
  const [modalOpen, setModalOpen] = useState(false);

  const handleSelectOffer = useCallback(
    (travelOffer: TravelOffer) => {
      if (travelOffer.id === selectedTravelOffer?.id) {
        setSelectedTravelOffer(null);
      } else {
        setSelectedTravelOffer(travelOffer);
      }
    },
    [selectedTravelOffer],
  );

  const handleOpenTravelOffer = useCallback((offer: TravelOffer) => {
    setSelectedTravelOffer(offer);
    setModalOpen(true);
  }, []);
  return (
    <Column sx={{ flex: 1 }}>
      <Row alignItems="center">
        <Typography variant="h6">Solicitudes de viaje</Typography>
        <IconButton
          onClick={() => {
            setPage(1);
            refetch();
          }}
          disabled={isFetching}
        >
          <Refresh />
        </IconButton>
      </Row>

      <Grid container spacing={2} sx={{ overflowX: "auto", pr: 2 }}>
        {offers.map((offer: any) => (
          <Grid item xs={12} sm={6} md={4} lg={3} key={offer.id}>
            <TravelCard
              travelOffer={offer}
              onClick={handleSelectOffer}
              isSelected={offer.id === selectedTravelOffer?.id}
              onEyeClick={handleOpenTravelOffer}
            />
          </Grid>
        ))}
      </Grid>
      <div ref={bottomRef} style={{ height: 1 }} />
      <TravelOfferDetailsModal open={modalOpen} travelOffer={selectedTravelOffer} onClose={() => setModalOpen(false)} />
    </Column>
  );
};

export default TravelsHistory;
